import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-sm-flex flex-column align-items-center" }

import BlogSelect from './components/BlogSelect.vue'
  // import PianoBlog from './components/PianoBlog.vue'
  import NodeExpressBlog from './components/NodeExpressBlog.vue'
  import BlogTwo from './components/BlogTwo.vue'
  import BlogFooter from './components/BlogFooter.vue'
  import BlogHeader from './components/BlogHeader.vue'
  import { ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const blogSelect = ref('1')
  const blogTitle = ref('Node JS Express for Beginners')
  const blogDate = ref('July 14, 2023')
  const readTime = ref('Read Time 4 minutes')

  function blogToggle(value: any) {
    blogSelect.value = value
    if (value === '1') {
      blogTitle.value = 'Node JS Express for Beginners'
      blogDate.value = 'July 14, 2023'
      readTime.value = 'Read Time 4 minutes'
    } else {
      blogTitle.value = 'Simple Tips & Tools'
      blogDate.value = 'November 27, 2020'
      readTime.value = 'Read Time 3 minutes'
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlogSelect, {
      onBlogSwitch: blogToggle,
      title: blogTitle.value
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BlogHeader, {
        title: blogTitle.value,
        date: blogDate.value,
        readTime: readTime.value
      }, null, 8, ["title", "date", "readTime"]),
      (blogSelect.value === '1')
        ? (_openBlock(), _createBlock(NodeExpressBlog, { key: 0 }))
        : _createCommentVNode("", true),
      (blogSelect.value === '2')
        ? (_openBlock(), _createBlock(BlogTwo, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(BlogFooter)
    ])
  ], 64))
}
}

})